<template>
  <div>
    <v-card v-if="showAdvanceOverview">
      <v-card-subtitle>
        <strong>Advances</strong>
      </v-card-subtitle>
      <div v-if="advances.length">
        <v-data-table
          :headers="headers"
          :items="advances"
        >
          <template v-slot:item.id="{ item }">
            <router-link-id
              :id="item.id"
              name="advance-view"
            />
          </template>
          <template v-slot:item.status_text="{ item }">
            <v-chip
              small
              :color="getColor(item.status)"
            >
              {{ item.status_text }}
            </v-chip>
          </template>
          <template v-slot:item.amount_fx="{ item }">
            {{ item.amount_fx | formatCurrencyV }}
          </template>
        </v-data-table>
      </div>
      <card-list-item
        v-else
        title="No Advances"
      />
    </v-card>
  </div>
</template>

<script>
import { fetchLotAdvances } from '../../../requests/lot'

export default {
  name: 'AdvancesOverview',
  props: {
    lotId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    showAdvanceOverview: false,
    advances: [],
    headers: [
      { text: 'id', value: 'id' },
      { text: 'Status', value: 'status_text' },
      { text: 'Currency', value: 'currency_text' },
      { text: 'Amount', value: 'amount_fx' }
    ]
  }),
  methods: {
    getColor (status) {
      return {
        OP: 'success',
        PD: 'warning',
        ST: 'primary',
        VD: 'error'
      }[status] || ''
    }
  },
  mounted () {
    fetchLotAdvances(this.lotId).then(response => {
      if (response.data) {
        this.advances = response.data
        this.showAdvanceOverview = true
      }
    })
  }
}
</script>
